import logo from '../imgs/white_indian.png'
import './Splash.css';
import React, {useState} from "react";
import TabContact from './TabContent/TabContact'
import TabHome from './TabContent/TabHome'
import TabDocuments from './TabContent/TabDocuments';
import TabNewsletters from './TabContent/TabNewsletters'
import SplashFooter from './TabContent/SplashFooter'
import { FiFileText, FiHome, FiInfo, FiLock, FiMail } from 'react-icons/fi';

import { useNavigate } from 'react-router-dom';



function Splash() {

  const [chosenTab, setChosenTab] = useState("Home")
  const navigate = useNavigate()

  const tabs = [
    { id: 'Home', label: 'Home', icon: FiHome },
    { id: 'Docs', label: 'Documents', icon: FiFileText },
    { id: 'Newsletters', label: 'Newsletter', icon: FiMail },
    { id: 'About', label: 'About', icon: FiInfo },
  ]

  const TabSplitter = () => {
    switch (chosenTab) {
      case "Home": return <TabHome />
      case "Docs": return <TabDocuments />
      case "About": return <TabContact />
      case "Newsletters": return <TabNewsletters />
      default: return <TabHome />
    }
  }

  return (
    <div className="App">
      <header className="App-header">
        <button className='brand-button' onClick={()=>setChosenTab("Home")} aria-label="Indian Park home">
          <span className='brand-mark'><img className='logo-img' src={logo} alt="" /></span>
          <span className='brand-copy'>
            <strong>Indian Park</strong>
            <small>Greenwood Lake, New York</small>
          </span>
        </button>

        <nav className='main-nav' aria-label="Primary navigation">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={()=>setChosenTab(id)}
              className={`nav-button ${chosenTab === id ? 'active' : ''}`}
              aria-current={chosenTab === id ? 'page' : undefined}
            >
              <Icon aria-hidden="true" />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        <button onClick={()=>navigate("/login")} className='login-nav-button'>
          <FiLock aria-hidden="true" />
          <span>Resident log in</span>
        </button>
      </header>

      <main className='mainContent'>
        {chosenTab && <TabSplitter />}
      </main>
      <SplashFooter />
    </div>
  );
}

export default Splash;
